import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {
  },

  actions: {
    // 获取用户基本信息
    async userBaseInfo ({ commit }, params) {
      const response = await axios.get('/diversion/v1/userBaseInfo', { params })
      return response.data
    },
    // 一键申请
    async batchApplyX ({ commit }, params) {
      const response = await axios.post('/diversion/v1/before-batch-apply', params)
      return response.data
    },
    // 获取字段配置-需要资料补充的字段
    async getFieldConfigX ({ commit }, params) {
      const response = await axios.post('/diversion/v1/getFieldConfig', params)
      return response.data
    },
    // 获取字段配置-需要资料补充的字段
    async saveBaseInfo ({ commit }, params) {
      const response = await axios.post('/diversion/v1/base-info', params)
      return response.data
    },
    // 批量申请-资料补充
    async saveBaseInfoBoth ({ commit }, params) {
      const response = await axios.post('/diversion/v1/user-batch-apply', params)
      return response.data
    },
    // 获取导流产品信息
    async getProductInfo ({ commit }, params) {
      const response = await axios.get('/diversion/v1/productInfo', { params })
      return response.data
    },
    async agreement ({ commit }, params) {
      const response = await axios.post('/diversion/agreement', params)
      return response.data
    },

    async ocrVerify ({ commit }, params) {
      const response = await axios.post('/diversion/v1/ocr-verify', params)
      return response.data
    },
    // 查授信结果
    async creditResult ({ commit }, params) {
      const response = await axios.post('/diversion/v1/credit-result', params)
      return response.data
    },
    // api授信结果风控banner
    async creditResultRiskBanner ({ commit }, params) {
      const response = await axios.get('/diversion/v1/api/result/risk-banner', { params })
      return response.data
    },
    // api授信结果弹窗跳转链接
    async creditResultPopup ({ commit }, params) {
      const response = await axios.get('/diversion/v1/api/result/risk-popup', { params })
      return response.data
    },
    // 单个授信申请
    async creditApply ({ commit }, params) {
      const response = await axios.post('/diversion/v1/credit-apply', params)
      return response.data
    },

    // 获取导流产品信息
    async productInfo ({ commit }, params) {
      const response = await axios.get('/diversion/v1/productInfo', { params })
      return response.data
    },
    // 融360表单回显
    async formBaseInfo ({ commit }, params) {
      const response = await axios.get('/diversion/v1/form-base-info', { params })
      return response.data
    },
    // 融360表单提交
    async formCommit ({ commit }, params) {
      const response = await axios.post('/diversion/v1/form-commit', params)
      return response.data
    },
    // 查询是否需要协议拼接
    async joinAgreement ({ commit }, params) {
      const response = await axios.post('/diversion/v1/query/join-agreement', params)
      return response.data
    },
    // 查询产品详情 不区分普通和api
    async configDetail ({ commit }, params) {
      const response = await axios.post('/loan-market/config-detail', params)
      return response.data
    }
  }
}
